import ProductCard from "components/General/ProductCard/ProductCard";

const MostPopular = ({ attrs }) => {
  const block_data = attrs?.data;
  const selected_products = block_data?.selecteer_producten;
  
  if (selected_products?.length < 1) return;

  return (
    <section className="px-4 mx-auto mb-16 md:mb-20 xl:px-0 max-w-app">
      <div className="col-span-12 md:col-span-9 md:col-start-2">
        <h2 className="mb-6 leading-none md:mb-10">
          {block_data?.titel || "Best verkocht"}
        </h2>
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-3 xl:grid-cols-4">
          {selected_products?.map((product, idx) => {
            return <ProductCard product={product} key={idx} />;
          })}
        </div>
      </div>
    </section>
  );
};

export default MostPopular;
